/* tslint:disable */
/* eslint-disable */
/**
 * Default API
 * All endpoints not defined under specific APIs
 *
 * OpenAPI spec version: Latest
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
import { HelpCentreListResponse } from '../models';
/**
 * HelpCentreApi - axios parameter creator
 * @export
 */
export const HelpCentreApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Provides a list of help centre items.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiHelpCentreListGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/HelpCentre/List`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * HelpCentreApi - functional programming interface
 * @export
 */
export const HelpCentreApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Provides a list of help centre items.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiHelpCentreListGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HelpCentreListResponse>> {
            const localVarAxiosArgs = await HelpCentreApiAxiosParamCreator(configuration).apiHelpCentreListGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * HelpCentreApi - factory interface
 * @export
 */
export const HelpCentreApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Provides a list of help centre items.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiHelpCentreListGet(options?: any): AxiosPromise<HelpCentreListResponse> {
            return HelpCentreApiFp(configuration).apiHelpCentreListGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * HelpCentreApi - object-oriented interface
 * @export
 * @class HelpCentreApi
 * @extends {BaseAPI}
 */
export class HelpCentreApi extends BaseAPI {
    /**
     * 
     * @summary Provides a list of help centre items.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HelpCentreApi
     */
    public apiHelpCentreListGet(options?: any) {
        return HelpCentreApiFp(this.configuration).apiHelpCentreListGet(options).then((request) => request(this.axios, this.basePath));
    }
}
